
class HomeClubHub extends HTMLElement {
  connectedCallback() {
    this.collectionsRoot = this.querySelector('[data-collections]');
    this.hint = this.querySelector('[data-club-hint]');
    this.discoverDefault = this.querySelector('[data-discover-default]');
    this.discoverClubPanels = this.querySelectorAll('[data-discover-club]');

    if (!this.collectionsRoot) return;

    this.selectedHandle = null;
    this.previewHandle = null;
    this.comingSoonLabel = this.dataset.comingSoonLabel || 'COMING SOON';

    document.addEventListener('brentbear:club-preview', (event) => this.applyPreview(event.detail));
    document.addEventListener('brentbear:club-select', (event) => this.applySelected(event.detail));
    document.addEventListener('brentbear:club-clear', () => this.applyIdle());

    const initialClub = new URLSearchParams(window.location.search).get('club');
    if (initialClub) {
      const clubData = this.getClubData(initialClub);
      if (clubData) this.applySelected(clubData);
    }
  }

  getClubData(handle) {
    const dataEl = this.querySelector(`[data-club-data][data-club-handle="${handle}"]`);
    if (!dataEl) return { handle };

    return {
      handle,
      name: dataEl.dataset.clubName,
      primary: dataEl.dataset.clubPrimary,
      secondary: dataEl.dataset.clubSecondary,
      active: dataEl.dataset.clubActive === '1',
    };
  }

  isClubActive(handle) {
    const dataEl = this.querySelector(`[data-club-data][data-club-handle="${handle}"]`);
    return dataEl ? dataEl.dataset.clubActive === '1' : false;
  }

  applyIdle() {
    this.selectedHandle = null;
    this.previewHandle = null;
    this.collectionsRoot.dataset.state = 'idle';
    this.collectionsRoot.style.removeProperty('--club-primary');
    this.collectionsRoot.style.removeProperty('--club-secondary');
    this.updateHint(this.dataset.idleHint || 'Beweeg over een club om de collecties te bekijken');
    this.toggleDiscover(null);
    this.updateCollectionLinks(null);
    this.updateCollectionImages(null);
  }

  applyPreview(detail) {
    if (!detail?.handle || this.selectedHandle) return;

    const active = detail.active ?? this.isClubActive(detail.handle);

    this.previewHandle = detail.handle;
    this.collectionsRoot.dataset.state = 'preview';
    this.setClubColors(detail);
    this.toggleDiscover(null);

    if (!active) {
      this.updateHint(`${detail.name} — ${this.comingSoonLabel}`);
      this.updateCollectionLinks(null);
      this.showComingSoon();
      return;
    }

    this.updateHint(`Bekijk ${detail.name}`);
    this.updateCollectionLinks(null);
    this.updateCollectionImages(detail.handle);
  }

  applySelected(detail) {
    if (!detail?.handle) return;

    const active = detail.active ?? this.isClubActive(detail.handle);

    this.selectedHandle = detail.handle;
    this.previewHandle = null;
    this.collectionsRoot.dataset.state = 'selected';
    this.setClubColors(detail);

    if (!active) {
      this.updateHint(`${detail.name} — ${this.comingSoonLabel}`);
      this.toggleDiscover(null);
      this.updateCollectionLinks(null);
      this.showComingSoon();
      return;
    }

    this.updateHint(`${detail.name} — kies een collectie`);
    this.toggleDiscover(detail.handle);
    this.updateCollectionLinks(detail.handle);
    this.updateCollectionImages(detail.handle);
  }

  showComingSoon() {
    this.collectionsRoot.querySelectorAll('[data-collection-card]').forEach((card) => {
      const media = card.querySelector('.home-club-hub__collection-media');
      if (!media) return;
      media.classList.remove('is-showing-club');
      media.classList.add('is-coming-soon');
    });
  }

  setClubColors(detail) {
    if (detail.primary) this.collectionsRoot.style.setProperty('--club-primary', detail.primary);
    if (detail.secondary) this.collectionsRoot.style.setProperty('--club-secondary', detail.secondary);
  }

  updateHint(text) {
    if (this.hint) this.hint.textContent = text;
  }

  updateCollectionLinks(handle) {
    this.collectionsRoot.querySelectorAll('[data-collection-card]').forEach((card) => {
      const link = card.querySelector('[data-collection-link]');
      if (!link) return;

      if (!handle) {
        link.setAttribute('href', '#');
        link.setAttribute('aria-disabled', 'true');
        link.tabIndex = -1;
        return;
      }

      let url = '#';
      try {
        const urls = JSON.parse(card.dataset.urls || '{}');
        url = urls[handle] || '#';
      } catch (_error) {
        url = '#';
      }

      link.setAttribute('href', url);
      link.removeAttribute('aria-disabled');
      link.tabIndex = 0;
    });
  }

  updateCollectionImages(handle) {
    this.collectionsRoot.querySelectorAll('[data-collection-card]').forEach((card) => {
      const media = card.querySelector('.home-club-hub__collection-media');
      const clubImage = card.querySelector('[data-image-club]');
      if (!media || !clubImage) return;

      media.classList.remove('is-coming-soon');

      if (!handle) {
        media.classList.remove('is-showing-club');
        clubImage.removeAttribute('src');
        clubImage.alt = '';
        return;
      }

      let imageUrl = '';
      try {
        const images = JSON.parse(card.dataset.images || '{}');
        imageUrl = images[handle] || '';
      } catch (_error) {
        imageUrl = '';
      }

      if (imageUrl) {
        clubImage.src = imageUrl;
        clubImage.alt = '';
        media.classList.add('is-showing-club');
      } else {
        clubImage.removeAttribute('src');
        clubImage.alt = '';
        media.classList.remove('is-showing-club');
      }
    });
  }

  toggleDiscover(handle) {
    if (this.discoverDefault) {
      this.discoverDefault.hidden = Boolean(handle);
    }

    this.discoverClubPanels.forEach((panel) => {
      panel.hidden = panel.dataset.discoverClub !== handle;
    });

    if (handle) {
      document.dispatchEvent(new CustomEvent('brentbear:shuffle-products'));
    }
  }
}

if (!customElements.get('home-club-hub')) {
  customElements.define('home-club-hub', HomeClubHub);
}
